import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import {
  IdentifierTypeUpdateCommand,
  IdentifierTypeViewModel
} from '../../../models/Entities/Person/IdentifierType/IdentifierTypeModels';

// store
import * as IdentifierTypesStore from '../../../redux/middleware/PersonIdentifierTypes.Middleware';

// functions
import { visibleIdentifierTypes } from './IdentifierTypes.Functions';

export interface IProps {}

interface ConnectedProps {
  isLoading: boolean | undefined;
  isLoadingSuccessfully: boolean | undefined;
  failOnLoading: boolean | undefined;
  error: ErrorType | undefined;
  /** Tipos no eliminados, en el orden del servidor (la grilla ordena). */
  identifierTypes: IdentifierTypeViewModel[];
}

interface DispatchProps {
  GetIdentifierTypes: () => void;
  /** PATCH .../status; `legacyCommand` es el respaldo con PUT si el servidor no tiene la ruta (Persons.API < 005). */
  ChangeIdentifierTypeStatus: (id: number, isActive: boolean, legacyCommand?: IdentifierTypeUpdateCommand) => Promise<IdentifierTypeViewModel>;
  DeleteIdentifierType: (id: number) => Promise<number>;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isLoading: state.PersonIdentifierTypes?.isLoadingAll,
  isLoadingSuccessfully: state.PersonIdentifierTypes?.successLoadingAll,
  failOnLoading: state.PersonIdentifierTypes?.failOnLoadingAll,
  error: state.PersonIdentifierTypes?.error,
  identifierTypes: visibleIdentifierTypes(state.PersonIdentifierTypes?.list),
  ...ownProps
});

export const mapDispatchToProps = {
  GetIdentifierTypes: IdentifierTypesStore.actionCreators.GetIdentifierTypes,
  ChangeIdentifierTypeStatus: IdentifierTypesStore.actionCreators.ChangeIdentifierTypeStatus,
  DeleteIdentifierType: IdentifierTypesStore.actionCreators.DeleteIdentifierType
};
